import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "advertiser/product-presubcategories";
const options = { role: ROLE.ADVERTISER };

export const GetPreSubCategoryList = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, { per_page: 1000, ...values })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};

export const GetPreSubCategoryDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/details?_id=${id}`)
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
